export default {
  WELCOME_YOU: 'Welcome',
  LOGIN_AND_REGISTRATION: 'Log in/Register',
  PLEASE_LOGIN: 'Please log in',
  LICENSE_INFORMATION: 'License information',
  ICP_INFO: 'Beijing ICP No. 11014788-5A',
  ABOUT_AMAZON: 'About the Amazon  Global Stores Purchase App',
  COMMENTED: 'Reviewed',
  TO_EVALUATE: 'To be reviewed',
  APPLICATION_MARKET_OPERATE:
    'Please upgrade in the app market, for review operations',
  CURRENT_VERSION: 'Current version',
  AD_PREFERENCES: 'Ad preference settings',
  PERS_REC: 'Personalized content rec.',
  PERS_CONTENT_RECOMMENDATION: 'Personalized content recommendation',
  ALLOW_PERS_REC:
    'Allow personalized content recommendations to enhance your browsing and shopping experience',
  MANAGE_AUTH: 'Manage my authorization',
  GS_PAPER_AND_ORDER_AUTH:
    'Global Stores purchase notice and order authorization',
  AUTH_FOR_BETTER_EXPERIENCE:
    'To better experience the  Global Stores purchase service sold and shipped from official Amazon sites outside of China, you have authorized the following:',
  AGREE_COLLECT_INFO:
    "Agree that amazon.cn collects and processes customers' names, addresses, mobile phone numbers, and identity card information or copies for customs clearance or to comply with laws including foreign exchange control.",
  AGREE_ACCESS_CUSTOMER_INFO_OVER_SEA:
    "Agree that the corresponding  Global Stores sales entity Amazon Export Sales LLC for Amazon  Global Stores Purchase obtains relevant information of customers' Amazon  Global Stores Purchase accounts to fulfill customer orders.",
  CANCEL_AUTH: 'Cancel authorization',
  RECOMMENDED_ASIN: 'Bestseller recommendations',
  CANCEL_AUTH_ALARM:
    'Canceling the authorization of Amazon  Global Stores Purchase customers, you will no longer be able to use the XXX account to buy  Global Stores purchase products.',
  CONSENT_AUTHORIZATION: 'Agree to authorize',
  AUTHORIZE_SUCCESSFULLY: 'Successfully authorized',
  CANCEL_AUTH_SUCCESSFULLY: 'Authorization canceled successfully',
  NOTIFICATION_REMINDER_SETTINGS: 'Message notification settings',
  SYSTEM_MESSAGE_SETTINGS: 'System message settings',
  ENABLED: 'Turned on',
  NOT_ENABLED: 'Not turned on, go to "Settings" to open',
  TURN_OFF_NOTIFICATION: 'Close message notifications',
  CLOSING_NOTIFICATION_REMIND:
    'Turning off message notifications will affect your shopping experience, missing important customer service messages, real-time order package tracking, and limited-time promotional offers.',
  CONTINUE_TO_CLOSE: 'Continue to turn off',
  KEEP_MESSAGES_NOTIFICATIONS: 'Retain message notifications',
  CLIENT_SETTINGS_MODIFY_PUSH_STATUS:
    'Please go to Client - Settings - Applications and Services - Application Management - Notification Management, to modify the push status',
  PRIVACY_AND_SECURITY: 'Privacy and Security',
  PRIVACY_STATEMENT: 'Privacy statement',
  USE_CONDITION: 'Terms of use',
  USE_CONDITION_FOR_AGS: 'Amazon  Global Stores Purchase terms of use',
  GET_MY_DATA: 'Get my data',
  GET_ALL_DATA_AT_AMAZON: 'Get all the data I generated on Amazon',
  CANCEL_ACCOUNT: 'Cancel account',
  SETTING: 'Settings',
  MANAGE_ADDRESS: 'Manage address information',
  CLEARANCE_INFO: 'Customs clearance information',
  MANAGE_ID_CARD_INFORMATION: 'Manage identity card information',
  GS_FOR_DOMESTIC_CUSTOMS_CLEARANCE:
    'Used for domestic customs clearance in  Global Stores purchases',
  MESSAGE_REMINDER: 'Message reminder settings',
  CURRENT_CACHE_USED_SPACE: 'Current cache space used',
  CLEAR_NOW: 'Clear now',
  SUCCESSFULLY_CLEARED: 'Clear successful',
  ACCOUNT_SAFETY: 'Account security',
  CONFIRM_CLEAR_CACHE: 'Clear local cache',
  CONFIRM: 'Confirm',
  CLEAR_CACHE: 'Clear cache',
  LOGOUT_FROM_APP:
    'You are logging out of the Amazon app from the current device',
  LOGOUT: 'Log out',
  CONFIRM_LOGOUT: 'Confirm to log out',
  CONTACT_CS: 'Contact customer service',
  GS_SHOPPING_PROCESS: 'Global Stores purchase process',
  AMZ_CONTACT_ME: 'Amazon contacts me',
  PLEASE_SELECT_ORDER: 'Please select an order',
  ORDER_LIST: 'Order list',
  ORDER_NUMBER: 'Order number',
  ORDER_TIME: 'Order time',
  TOTAL: 'Total',
  PIECE: 'Pieces',
  WE_WILL_CONTACT_YOU_LEAVE_YOUR_PHONE_NUMBER:
    'We will contact you immediately, please leave your phone number',
  PLEASE_ENTER_MOBILE_PHONE_NUMBER:
    'Please enter an 11-digit mobile phone number for the mainland China region in the standard format, such as: 138 XXXX XXXX.',
  JUST_CLICK_THE_AMZ_CONTACT_ME:
    'Click the "Amazon contact me" button to use this free service.',
  TELEPHONE_NUMBER: 'Telephone number',
  PLEASE_ENTER_YOUR_TELEPHONE_NUMBER: 'Please enter your telephone number',
  CONNECTING: 'Connecting',
  CONNECTING_YOU_TO_A_SEAT: 'Please wait, connecting you to a representative',
  UNDER_SYSTEM_MAINTENANCE: 'System maintenance',
  CONTACT_US_AT_THE_FOLLOWING_NUMBERS: 'Please call us at the following number',
  PLEASE_CALL: 'Please call',
  NON_WORKING_HOURS: 'Non-working hours',
  WORKING_HOURS_OF_AMAZON:
    'Amazon  Global Stores Purchase customer service hours:',
  EVERY_DAY: 'Every day',
  CHINA_TIME_ZONE: 'China time zone',
  WELCOME_TO_CONTACT_US_DURING_WORKING_HOURS:
    'We welcome you to contact us during working hours,',
  WE_WILL_SOLVE_YOUR_PROBLEM: 'We will solve your problem as soon as possible',
  I_SEE: 'I know',
  THE_FORMAT_OF_MOBILE_PHONE_NUMBER_IS_INCORRECT:
    'The mobile phone number format is incorrect, please re-enter',
  NO_DATA: 'No data available',
  NO_MORE: 'No more',
  TRANSACTION_NOTIFICATION: 'Transaction notification',
  MESSAGE_CENTER: 'Message center',
  MARKED_READ: 'All read',
  DELETE_MY_ACCOUNT: 'Delete my account',
  DELETE_ACCOUNT_IS_A_PERMANENT_OPERATION:
    'Deleting the account is a permanent operation',
  REASON_FOR_DELETE_AMZN_ACCOUNT:
    'Please select the reason for deleting your Amazon account',
  PLEASE_SELECT: 'Please Select',
  DELETE_MY_AMZN_ACCOUNT_AND_DELETE_MY_DATA:
    'I want to permanently delete my Amazon account and delete my data',
  CONFIRM_TO_CANCEL_DELETE_ACCOUNT:
    'After deletion, all data and information of this account will be emptied and cannot be recalled, are you sure you want to cancel?',
  DELETE_REQUEST_CANNOT_BE_SUBMITTED:
    'Your request to delete your Amazon account and delete data cannot be submitted at this time. Please try again later. If you still encounter problems, please',
  CONTACT_US: 'Contact us',
  PLEASE_SELECT_THE_REASON_FOR_DELETE_ACCOUNT:
    'Please select a reason for deletion',
  SELECT_REASON_FOR_DELETE_ACCOUNT: 'Select a reason for delete the account',
  CHECK_THE_TERMS_TO_CONFIRM:
    'Please check the terms at the bottom of the page to confirm',
  APPLY_FOR_DELETE_ACCOUNT: 'Apply for deletion',
  SUBMITTED_SUCCESSFULLY: 'Submission successful',
  FAILED_TO_DELETE_AMZN_ACCOUNT: 'Amazon account deletion failed',
  NO_NEED_TO_CONFIRM_AGAIN:
    'Your application has been confirmed, no need to confirm again',
  DELETE_ACCOUNT_REQUEST_SUBMITTED: 'deletion of account application submitted',
  DELETE_ACCOUNT_CONFIRMATION_NOTIFICATION_REMINDER:
    'We have sent you a confirmation notification link. If you need to continue with the account deletion operation, please check your text messages. Please confirm the account deletion operation via SMS. Please note that the confirmation link will expire 5 days after being sent.',
  CANCEL_DELETE_AMZN_ACCOUNT: 'Cancel the deletion of the Amazon account',
  YOUR_ACCOUNT_CAN_CONTINUE_TO_BE_USED_AFTER_CANCEL_DELETE:
    'After cancelling the deletion of the account, your account will not be deteletd and can continue to be used.',
  CANCEL_DELETE_ACCOUNT: 'Cancel deletion',
  CANCEL_DELETE_ACCOUNT_SUCCESSFULLY: 'Cancellation of deletion successful',
  PROCESSING_DELETE_ACCOUNT_REQUEST:
    'The request to delete the Amazon account is being processed',
  ALREADY_REVIEWED_REQUESTS_TO_DELETE_ACCOUNT_AND_DATA:
    'We have reviewed your request to delete the Amazon account and delete the data.',
  IF_YOU_DO_NOT_WANT_TO_DELETE_YOUR_ACCOUNT_AND_DELETE_DATA:
    'If you do not want to delete your Amazon account and delete the data, please click "Cancel account cancellation" below.',
  TERMINATE_ACCOUNT_DELETE: 'Cancel account deletion',
  TERMINATE_ACCOUNT_DELETE_SUCCESSFULLY: 'Cancel account deletion successful',
  APPLY_TO_OBTAIN_MY_PERSONAL_DATA: 'Apply for my personal data',
  PLEASE_SELECT_THE_DATA_I_WANT: 'Please select the data you want',
  SUBMIT_APPLICATION: 'Submit application',
  SUBMISSION_FAILED_PLEASE_RESUBMIT: 'Submission Failed ,Please Resubmit',
  SELECT_THE_DATA_I_WANT: 'Select the data I want',
  DATA_REQUEST_CREATED: 'Data request creation',
  DATA_REQUEST_CONFIRMED: 'Data request confirmation',
  DATA_CONFIRMATION_EMAIL:
    "Protecting your privacy and data security is always Amazon's top priority. We have sent a confirmation link to your email, you need to click the link to verify your request. Please note that this link will expire after 5 days.",
  CONFIRMATION_FAILED_PLEASE_RECONFIRM: 'Confirmation failed, please reconfirm',
  DATA_ACQUISITION: 'Data acquisition',
  DOWNLOAD_AMZN_DATA:
    "Protecting your privacy and data security is always Amazon's top priority. You can download your Amazon data, which will expire after XXX days.",
  YOUR_DATA_WILL_EXPIRE: 'Your data will expire on XXX.',
  DOWNLOAD_DATA: 'Download data',
  FILE_IS_OUT_OF_DATE: 'File has expired',
  SYSTEM_TIMEOUT_TRY_AGAIN_LATER: 'System timeout, please try again later',
  NO_CACHE_TO_CLEAR: 'No cache available to clear'
};
